// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, socialLoginProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSocialLoginProfessionalApi = createAsyncThunk(
  "hitSocialLoginProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + socialLoginProfessional;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message || "Professional social login failed";
      showToast(message, "error");
      throw error?.response?.data || { status: false, message };
    }
  }
);

const SocialLoginProfessionalSlice = createSlice({
  name: "socialLoginProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearHitSocialLoginProfessionalApi: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSocialLoginProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSocialLoginProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status === true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem(
            "professionalToken",
            action.payload.data.accessToken,
          );
          localStorage.setItem("professionalId", action.payload.data._id);
          localStorage.setItem(
            "professionalData",
            JSON.stringify(action.payload.data),
          );
        }
      })
      .addCase(hitSocialLoginProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearHitSocialLoginProfessionalApi } = SocialLoginProfessionalSlice.actions;
export default SocialLoginProfessionalSlice.reducer;
